import type { MobilePlatform } from '../utils/mobilePlatform';

export const MOBILE_APP_STORE_URLS: Record<MobilePlatform, string> = {
  android: 'https://play.google.com/store/apps/details?id=com.sangoma.teamhub.mobile',
  ios: 'https://apps.apple.com/ca/app/teamhub/id1618997140',
};

export const MOBILE_APP_ANDROID_PACKAGE = 'com.sangoma.teamhub.mobile';
